import { inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Company } from '@app/features/companies/company.model';
import { CompanyService } from '@app/features/companies/company.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'companyIdToCompany',
})
export class CompanyIdToCompanyPipe implements PipeTransform, OnDestroy {
  private companyService = inject(CompanyService);
  private companiesMap = new Map<string, Company>();
  private sub: Subscription;

  constructor() {
    this.sub = this.companyService.allCompanies$.subscribe((companies) => {
      this.companiesMap.clear();
      for (const company of companies) {
        this.companiesMap.set(company.id, company);
      }
    });
  }

  transform(companyId?: string | null): Company | null {
    if (!companyId) return null;
    return this.companiesMap.get(companyId) ?? null;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
